import { isCI, isDev } from 'src/config';

export const overflowMenuCSSId = 'overflow-menu';

// Flag used to make running Cypress tests easier in CI (and locally in Dev when included).
export const cypressFlag = isDev || isCI;

export const learnHowToContributeUrl =
  'https://docs.aline.co/en/articles/8148859-contributing-to-the-aline-community';

export const tooltipMsg = {
  notWFEditor: 'Only workflow editors can edit a workflow',
  placeholder:
    'Placeholders are temporary collaborators you can assign to steps and reassign later. For example, "Attorney" or "Vice President".',
  recipientNotEditable: 'Workflow recipient is no longer editable',
  wFIsReadOnly: 'Workflow is read only',
  wFNotPaused: 'Pause the workflow to edit',
  wFSectionNotEditable: 'Workflow section is no longer editable',
} as const;
